import { getDialogHooks } from 'utilities/dialog-context/dialog-context-helpers';
import AssignTextMessageDialog, {
  AssignTextMessageDialogCallbackInput,
  AssignTextMessageUniqueProps,
} from '../assignTextMessageDialog';

const { useDialogForContext, useDialog: useAssignTextMessageDialog } =
  getDialogHooks<
    AssignTextMessageUniqueProps,
    AssignTextMessageDialogCallbackInput
  >(AssignTextMessageDialog);
export const useAssignTextMessageDialogForContext = useDialogForContext;
export default useAssignTextMessageDialog;
